import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { ERROR_MESSAGE_SERVICE, ErrorMessageService, LOG_SERVICE, LogService } from "@cervval.js/common/services";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { ErrorWithCode } from "@cervval.js/common/src/errors/errors";
import { I18nType, i18n } from "./i18n/i18n";


@CustomElement({
    name: "cjs-confirm-validation-key",
    style: require("./confirmValidationKey.component.scss"),
    template: require("./confirmValidationKey.component.html"),
    i18n
})
export class CjsConfirmValidationKey extends WebComponent<I18nType> {

    @Injected(LOG_SERVICE, { optional: true })
    protected readonly _log?: LogService;

    @Injected(ERROR_MESSAGE_SERVICE)
    protected readonly _errorMessageService!: ErrorMessageService;

    /** components */
    @TypedHtmlElements()
    private readonly _components!: {
        confirmValidationKeyContainer: HTMLDivElement,
        confirmValidationKeyTitle: HTMLParagraphElement,
        confirmValidationKeyForm: HTMLFormElement,
        loginInput: HTMLInputElement,
        keyInput: HTMLInputElement,
        errorMessage: HTMLButtonElement,
        confirmValidationKeyButton: HTMLButtonElement
    };

    constructor(
        protected _onKeyConfirm: (login: string, key: string) => Promise<void>) {
        super();
    }


    /** Init component display */
    public override init(): void {
        this._components.confirmValidationKeyTitle.innerText = this.i18n.confirmValidationKeyTitle.innerText;
        this._components.loginInput.placeholder = this.i18n.loginInput.placeholder;
        this._components.keyInput.placeholder = this.i18n.keyInput.placeholder;
        this._components.confirmValidationKeyButton.innerHTML = this.i18n.confirmValidationKeyButton.innerHTML;
        this._bindInputActions();
    }

    /**
     * Will call refresh pethod for password input modifications
     */
    private _bindInputActions(): void {
        this._components.confirmValidationKeyButton.onclick = () => {
            this._clearError();
            this._onKeyConfirm(this._loginValue, this._keyValue).catch((e: ErrorWithCode) => this._showErrorFromErrorCode(e));
        };
    }

    /**
     * Return the value of the login form input
     */
    private get _loginValue(): string {
        return this._components.loginInput.value;
    }

    /**
     * Return the value of the key form input
     */
    private get _keyValue(): string {
        return this._components.keyInput.value;
    }

    /**
     * Set the value of the login form input
     */
    public setLoginValue(value: string): void {
        this._components.loginInput.value = value;
    }

    /**
     * Set the value of the key form input
     */
    public setKeyValue(value: string): void {
        this._components.keyInput.value = value;
    }

    /**
     * Clear the visible error
     */
    private _clearError(): void {
        this._components.errorMessage.innerText = "";
        this._components.errorMessage.classList.remove("visible");
    }

    /**
     * Display error from the error code
     * @param error error containing the return code
     * @returns 
     */
    private _showErrorFromErrorCode(error: ErrorWithCode): Promise<void> {
        return this._errorMessageService.getErrorMessage(error).then(errorMessage => this._showError(errorMessage));
    }

    /**
     * Display error from a text
     * @param errorMessage 
     */
    private _showError(errorMessage: string): void {
        if (errorMessage) {
            this._components.errorMessage.innerText = errorMessage;
            this._components.errorMessage.classList.add("visible");
        } else {
            this._log?.warn("Trying to show error with empty message");
        }
    }
}